import React, { useState, useEffect } from "react";
import { FaCheck, FaYoutube } from "react-icons/fa6";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import Modal from "react-modal";
import { toast } from "react-toastify";
import { httpReauest } from "../../utils/httpRequest";
import Loading from "../common/Loading";

const WatchVideoTask = ({ user, reward }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [claimed, setclaimed] = useState(false);
  const [timeLeft, setTimeLeft] = useState();
  const [hasWatchedEnough, setHasWatchedEnough] = useState(false);
  const [loading, setloading] = useState(true);
  const [data, setdata] = useState();

  useEffect(() => {
    let interval;
    if (modalOpen && timeLeft > 0) {
      interval = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setHasWatchedEnough(true);
    }
    return () => clearInterval(interval);
  }, [modalOpen, timeLeft]);

  const handleModalClose = () => {
    setModalOpen(false);
    if (!hasWatchedEnough) {
      toast.warning("⏳ You must watch the full video to claim the reward.");
    }
  };

  useEffect(() => {
    if (modalOpen && !data) {
      getData();
    }
  }, [modalOpen]);

  async function getData(params) {
    const res = await httpReauest("GET", "/user/youtube-video", {}, {});
    setdata(res.data?.data);
    setTimeLeft(res.data?.data?.duration);
    setloading(false);
  }

  async function climReward(params) {
    const user = JSON.parse(localStorage.getItem("user"));
    await httpReauest(
      "POST",
      "/user/watch/youtube",
      {},
      { "x-access-token": user?.token }
    ).then(() => {
      toast.success("🎉 Reward claimed!");
      setModalOpen(false);
      setclaimed(true);
    });
  }

  return (
    <div
      className={`${
        (user?.youtubeVideo?.watched || claimed) && "order-last opacity-40"
      } flex justify-between gap-3 items-center relative py-2 pb-4 border-b`}
    >
      <span className="flex items-center gap-2 lg:gap-4">
        <FaYoutube className="text-[32px] sm:text-[54px] lg:text-[72px]" />
        <span>
          <h4 className="font-bold text-[14px] lg:text-[28px] lg:-mb-2">
            Watch a Youtube Video
          </h4>
          <span className="font-bold text-[16px] lg:text-[28px] flex gap-1 items-center">
            <img src="/gold.png" className="w-6 lg:w-8" alt="GOLD" />+{reward}{" "}
            daily
          </span>
        </span>
      </span>

      <button
        className="start-button px-4 lg:px-8 flex gap-2 items-center py-2 bg-[#02006A] text-white rounded-full text-[14px] lg:text-[24px]"
        onClick={() => {
          setModalOpen(true);
          setTimeLeft(data?.duration);
          setHasWatchedEnough(false);
        }}
        disabled={user?.youtubeVideo?.watched}
      >
        {user?.youtubeVideo?.watched || claimed ? (
          <>
            <FaCheck color="green" /> Claimed
          </>
        ) : (
          "Start"
        )}
      </button>

      <Modal
        isOpen={modalOpen}
        onRequestClose={handleModalClose}
        contentLabel="Watch Video"
        className="max-w-3xl mx-auto my-10 bg-white p-6 rounded-xl shadow-xl relative lg:min-w-[580px]"
        overlayClassName="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50"
      >
        {loading ? (
          <Loading />
        ) : (
          <div className="flex flex-col items-center gap-4">
            <div className="w-24 h-24">
              <CircularProgressbar
                value={(1 - timeLeft / data?.duration) * 100}
                text={`${timeLeft}s`}
                styles={buildStyles({
                  textColor: "#02006A",
                  pathColor: "#FFD700",
                  trailColor: "#eee",
                })}
              />
            </div>
            <p className="font-bold text-lg">Time until reward</p>

            <div className="w-full aspect-video">
              <iframe
                className="w-full h-full"
                src={`https://www.youtube.com/embed/${data?.url}?autoplay=1`}
                title="YouTube video"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
            </div>

            {hasWatchedEnough && (
              <button
                className="mt-4 px-6 py-2 bg-green-600 text-white rounded-full"
                onClick={() => {
                  climReward();
                }}
              >
                Claim Reward
              </button>
            )}
          </div>
        )}
      </Modal>
    </div>
  );
};

export default WatchVideoTask;
